import { getData, patchData } from "adminApi/apiClient";

const API_URL = "weekly-holidays";

export const GetAllWeeklyHolidays = async () => {
    try {
        const result = await getData(`/${API_URL}`);
        return {
            data: {
                success: true,
                data: result.data || result,
            },
        };
    } catch (error) {
        console.error(`Get Weekly Holiday API error:`, error);
        return {
            data: {
                success: false,
                error: error.message,
            },
        };
    }
};

export const UpdateWeeklyHoliday = async (id, data) => {
    try {
        const result = await patchData(`/${API_URL}/manage/${id}`, data);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error(`Update Weekly Holiday API error:`, error);
        return {
            data: {
                success: false,
                error: error.message,
            },
        };
    }
};

